//////////////////////////////////////////////////////////
//                                                      //
//  ENDPOINT -> /trocar_senha/*?loja=*                  //
//      * NO PARÂMETRO QUER DIZER QUE A UTILIZAÇÃO      //  
//        DO PARÂMETRO DEPENDE DA FORMA DE LOGIN        //
//          DA PÁGINA (CLIENTE OU FRANQUEADO) *         //
//                                                      //
//  PÁGINA PARA TROCAR A SENHA DO PERFIL.               //
//                                                      //
//  CASO SEJA UM PERFIL DE FRANQUEADO, RECEBE COMO      //
//  PARÂMETRO NA URL O ID DA LOJA, CASO SEJA UM PERFIL  //
//  DE CLIENTE, NÃO RECEBE NADA COMO PARÂMETRO NA URL.  //
//                                                      //
//////////////////////////////////////////////////////////



import React from "react"

import ContinuarComprando from "../components/continuar_comprando";

import api from "../services/api";


function trocarSenha() {

  window.onload = async function() {
    // FUNÇÃO CHAMADA NO CARREGAMENTO DESTA PÁGINA ('/trocar_senha/*loja=*')

    if(sessionStorage['login'].includes('/')){  // VERIFICA SE O USUÁRIO ESTÁ LOGADO COMO FRANQUEADO

      var params = window.location.search
      var urlparams = new URLSearchParams(params)
      var loja = urlparams.get('loja')
      
      if(loja != sessionStorage['loja']){  // VERIFICA SE A LOJA DA URL É A MESMA LOJA DA SESSION
        window.location.href = '/trocar_senha/?loja='+ sessionStorage['loja']  // CASO NÃO SEJA, REDIRECIONA PARA A PÁGINA DA LOJA DA SESSION  
      }
      
      var login = await api.post('verificar_login',{  // VERIFICA NO DB SE A LOJA CORRESPONDE AO TOKEN E TAMBÉM BUSCA O VALOR DO ESTOQUE DE SEGURANÇA DA LOJA
        "id_loja": sessionStorage['loja'],
        "login": sessionStorage['login']
      }).then((response) => {
        return response
      })    
      // login['data'] RETORNA UM DICIONÁRIO COM AS CHAVES
        // 'login' ->  BOOLEANO QUE DEFINE SE O USUÁRIO PODE PERMANECER NA PÁGINA

        // 'id' -> STRING COM O ID DO USUÁRIO CORRETO
          // ISSO OCORRE CASO 'login' SEJA FALSO PORQUE OS TOKENS DE LOGIN SAO INCOMPATÍVEIS
          // CASO 'login' SEJA FALSO E O TERMO 'id' NÃO ESTEJA NO DICIONÁRIO, O USUÁRIO NÃO FOI ENCONTRADO NO DB
      
        // 'estoque_seguranca' -> INT COM O VALOR DO ESTOQUE DE SEGURANÇA QUE ESTÁ SALVO NO DB
          // ESSE VALOR APARECE NO DICIONÁRIO APENAS SE LOGIN FOR TRUE      
      
      if(!login['data']['login']){  // SE NÃO CORRESPONDER
        sessionStorage['loja'] = login['data']['id']  // TROCA A LOJA DA SESSION
        window.location.href = '/trocar_senha?loja='+ login['data']['id']  // E REDIRECIONA PARA A PÁGINA DA LOJA CORRETA
      }
    }
    else{  // CASO O USUÁRIO ESTEJA LOGADO COMO CLIENTE, REDIRECIONA PARA A PÁGINA DE TROCA DE SENHA DE CLIENTES
      if(window.location.pathname != '/trocar_senha'){
        window.location.href = '/trocar_senha'
      }
    }
   }

  async function teste_submit(){  // FUNÇÃO PARA SUBMETER A SENHA NOVA NO DB
    // FUNÇÃO CHAMADA NO CLICK DO BOTÃO 'btn-trocar-senha' DESTA PÁGINA

    document.getElementById('senha').classList.remove('border-erro')  // REMOVE OS ERROS ANTERIORES
    document.getElementById('senha_confirmar').classList.remove('border-erro')

    var submit = true

    if(document.getElementById('senha').value !== document.getElementById('senha_confirmar').value){  // CASO A SENHA E A CONFIRMAÇÃO POSSUAM VALORES DIFERENTES
      document.getElementById('senha').classList.add('border-erro')  // APONTA ERRO
      document.getElementById('senha_confirmar').classList.add('border-erro')

      submit = false  // NÃO SUBMETE
    }
    else{  // CASO SENHA E CONFIRMAÇÃO POSSUAM OS MESMOS VALORES
      if (document.getElementById('senha').value == ''){  // MAS O VALOR DA SENHA FOR VAZIO
        document.getElementById('senha').classList.add('border-erro')  // APONTA ERRO NA SENHA

        submit = false  // NÃO SUBMETE
      }
      if (document.getElementById('senha_confirmar').value == ''){  // MAS O VALOR DA CONFIRMAÇÃO FOR VAZIO
        document.getElementById('senha_confirmar').classList.add('border-erro')   // APONTA ERRO NA CONFIRMAÇÃO

        submit = false  // NÃO SUBMETE
      }
    }

    if (submit){  // CASO NÃO EXISTAM ERROS
      if(sessionStorage['login'].includes('/')){  // E O USUÁRIO ESTIVER LOGADO COMO FRANQUEADO
        var trocar_senha = await api.post('trocar_senha',{  // SUBMETE A SENHA NOVA NO DB NA TABELA DE FRANQUEADOS
          "senha": document.getElementById('senha').value,
          "login": sessionStorage['login']
        }).then((response) => {
          return response
        })     
        // 'trocar_senha' NÃO RETORNA NADA
        
        window.location.href = '/?id=' + sessionStorage['loja']  // APÓS TROCAR A SENHA, REDIRECIONA DE VOLTA PARA A HOME

      }
      else{  // E O USUÁRIO ESTIVER LOGADO COMO CLIENTE
        var trocar_senha = await api.post('trocar_senha_usuario',{  // SUBMETE A SENHA NOVA NO DB NA TABELA DE CLIENTES
          "senha": document.getElementById('senha').value,  
          "login": sessionStorage['login']
        }).then((response) => {
          return response
        })     
        
        window.location.href = '/?id='+sessionStorage['loja']  // APÓS TROCAR A SENHA, REDIRECIONA DE VOLTA PARA A HOME
      }
    }
  }

  // CONDIÇÃO DE LOGIN
  if(!sessionStorage['login']){
    window.location.href = '/?id='+ sessionStorage['loja']     
  }
  else{

    // OS COMPONENTES DA PÁGINA SÃO (NA ORDEM QUE APARECEM):
      // 'ContinuarComprando' -> VERSÃO DO HEADER QUE NÃO APARECE A BARRA DE PESQUISA E SIM BOTÃO DE VOLTAR PARA A PÁGINA HOME

    return(
      <div>
            <div>
              <ContinuarComprando />
            </div>

        <div class='custom-container card-checkout px-0 pt-3 mt-10'>

        <div class='px-0 py-0 mx-0 border-bottom'>
          <div class="col-12 py-0 px-3 mx-0 mb-3">
              <h5 class='montserrat verde'>Senha</h5>
              <input id='senha' type='password' class='w-100 no-outline busca border-redonda tamanho-filtro px-2'></input>
          </div>
          <div class="col-12 py-0 px-3 mx-0 mb-3">
              <h5 class='montserrat verde'>Confirmar Senha</h5>
              <input id='senha_confirmar' type='password' class='w-100 no-outline busca border-redonda tamanho-filtro px-2'></input>
          </div>                      
        </div>

        <div class="my-4">
            <div class='col col-12 row px-2 mx-0'>
                <div class="px-0 row col col-12 mx-0">
                    <div id='msg' class='mx-0 px-0 vermelha montserrat col-9'>

                    </div>
                    <div class="col-3 px-0 mx-0">
                      <button id='btn-trocar-senha' class="btn-verde pull-right" onClick={teste_submit}>
                        <i class="fa fa-check mr-4 montserrat"></i>Confirmar
                      </button>
                    </div>
                </div>
            </div>
        </div>
        </div>
      </div>
    )
  }
}

export default trocarSenha;
